import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { getEmailJSConfig, isEmailJSConfigured } from '../../config/emailjs';
import { socialLinks } from '../../data/portfolio';
import { trackContactSubmission } from '../../analytics/AnalyticsController';

const Contact = () => {
  const [status, setStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isEmailJSConfigured()) return;
    setIsSubmitting(true);
    setStatus(null);
    const form = event.currentTarget;
    const formData = new FormData(form);
    const { SERVICE_ID, TEMPLATE_ID, USER_ID } = getEmailJSConfig();
    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, {
        from_name: formData.get('name'),
        from_email: formData.get('email'),
        professional_role: formData.get('professional_role'),
        company: formData.get('company'),
        subject: formData.get('subject'),
        message: formData.get('message'),
        to_email: 'muhammednihas2218@gmail.com',
      }, USER_ID);
      form.reset();
      trackContactSubmission();
      setStatus({ type: 'success', message: 'Message sent. I’ll get back to you soon.' });
    } catch {
      setStatus({ type: 'error', message: 'The form could not send your message. Please email me directly.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section contact-section" id="contact" aria-labelledby="contact-title">
      <div className="shell contact-grid">
        <div>
          <span className="section-number">08 / CONTACT</span>
          <h2 id="contact-title">Let's build<br /><em>what's next.</em></h2>
          <p>Interested in agentic systems, retrieval, or production AI? I’m open to thoughtful engineering conversations.</p>
          <div className="contact-methods">
            <div className="contact-method">
              <span className="contact-method-label">EMAIL</span>
              <a href="mailto:muhammednihas2218@gmail.com">muhammednihas2218@gmail.com <span aria-hidden="true">↗</span></a>
            </div>
            <div className="contact-method">
              <span className="contact-method-label">MOBILE</span>
              <a href="tel:+918589932218">+91 8589932218 <span aria-hidden="true">↗</span></a>
            </div>
          </div>
          <div className="contact-social">{socialLinks.map((link) => <a href={link.url} target="_blank" rel="noopener noreferrer" key={link.label}>{link.label} <span aria-hidden="true">↗</span></a>)}</div>
        </div>
        <div className="contact-side">
          {isEmailJSConfigured() ? <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Start a conversation</h3>
            <div className="form-row"><label htmlFor="contact-name">Name<input id="contact-name" name="name" type="text" autoComplete="name" required maxLength="120" /></label><label htmlFor="contact-email">Email<input id="contact-email" name="email" type="email" autoComplete="email" required maxLength="254" /></label></div>
            <div className="form-row"><label htmlFor="contact-role">Professional role <span className="optional-label">optional</span><input id="contact-role" name="professional_role" type="text" autoComplete="organization-title" maxLength="120" /></label><label htmlFor="contact-company">Company <span className="optional-label">optional</span><input id="contact-company" name="company" type="text" autoComplete="organization" maxLength="120" /></label></div>
            <label htmlFor="contact-subject">Subject<input id="contact-subject" name="subject" type="text" required maxLength="160" /></label>
            <label htmlFor="contact-message">Message<textarea id="contact-message" name="message" rows="5" required maxLength="5000" /></label>
            <p className="form-disclosure">I’ll use the details you provide only to reply to your inquiry. The message is sent through EmailJS to my inbox and is not connected to anonymous site analytics. <a href="/privacy.html">Read the privacy notice</a>.</p>
            {status && <p className={status.type === 'error' ? 'form-status is-error' : 'form-status'} role={status.type === 'error' ? 'alert' : 'status'}>{status.message}</p>}
            <button className="button button-primary" type="submit" disabled={isSubmitting}>{isSubmitting ? 'Sending…' : 'Send message'} <span aria-hidden="true">↗</span></button>
          </form> : <div className="contact-note"><span className="mono">DIRECT CONTACT</span><p>For opportunities, collaboration, or a technical conversation, send me an email directly.</p><a className="button button-primary" href="mailto:muhammednihas2218@gmail.com?subject=Portfolio%20inquiry">Open email <span aria-hidden="true">↗</span></a></div>}
        </div>
      </div>
    </section>
  );
};

export default Contact;
